import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import TermSheetSignUI from './TermSheetSignUI.js'

class TermSheetSignSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // html to pdf generation
      generateTShtml2pdfSubmitted: false,
      generateTShtml2pdfErrorList: [],
      //
      tsPDFUploadMode: false,
      tsPDFFileId: null,
      tsPDFName: null,
      tsPDFType: null,
      tsPDFSize: null,
      tsPDFUploadSuccessMsg: null,
      tsPDFUploadErrorList: null,
      tsPDFUploadSubmitted: false,
      //
      genLeegTSfromHTMLErrorList: null,
      genLeegTSfromHTMLSuccessMsg: null,
      genLeegTSfromHTMLSubmitted: false,
    
      documentList: null,
      downloadRequested: false,
      fileErrorList: null,
    }
  }

  render() {
    return (
      <TermSheetSignUI
        context={this.props.context}
        loan={this.props.loan}
        onRefreshClick={this.props.onRefreshClick}
        // html to pdf generation
        onGenerateTShtml2pdf={this.onGenerateTShtml2pdf}
        generateTShtml2pdfSubmitted={this.state.generateTShtml2pdfSubmitted}
        generateTShtml2pdfErrorList={this.state.generateTShtml2pdfErrorList}
        // generate leegality term sheet from html
        onGenLeegTSfromHTML={this.onGenLeegTSfromHTML}
        genLeegTSfromHTMLSuccessMsg={this.state.genLeegTSfromHTMLSuccessMsg}
        genLeegTSfromHTMLErrorList={this.state.genLeegTSfromHTMLErrorList}
        genLeegTSfromHTMLSubmitted={this.state.genLeegTSfromHTMLSubmitted} 
        //
        tsPDFUploadMode={this.state.tsPDFUploadMode}
        onTSPDFUploadClick={() => { this.setState({ tsPDFUploadMode: true }) }}
        onTSPDFUploadCancel={() => { this.setState({ tsPDFUploadMode: false }) }}
        onTSPDFUpload={this.onTSPDFUpload}
        tsPDFFileId={this.state.tsPDFFileId}
        tsPDFName={this.state.tsPDFName}
        tsPDFType={this.state.tsPDFType}
        tsPDFSize={this.state.tsPDFSize}
        tsPDFUploadSuccessMsg={this.state.tsPDFUploadSuccessMsg}
        tsPDFUploadErrorList={this.state.tsPDFUploadErrorList}
        tsPDFUploadSubmitted={this.state.tsPDFUploadSubmitted}
        //
        selectedDocId={this.state.selectedDocId}
        docSubmitted={this.state.docSubmitted}
        documentList={this.state.documentList}
        onDownloadDocClick={this.onDownloadDocClick}
        downloadRequested={this.state.downloadRequested}
        fileErrorList={this.state.fileErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDocuments()
  }

  // term sheet pdf generat ----------------------------------------------------
  onGenerateTShtml2pdf = () => {
    let submitted = this.state.generateTShtml2pdfSubmitted
    if (submitted)
      return

    this.setState({
      generateTShtml2pdfErrorList: [],
      generateTShtml2pdfSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet/template/fileDownloadSignedUrl`,
      this.onGenerateTShtml2pdfCallback, {}
    )
  }

  onGenerateTShtml2pdfCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      generateTShtml2pdfErrorList: errorList,
      generateTShtml2pdfSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ generateTShtml2pdfErrorList: [] })
      }, 10000)
    }
  }

  onTSPDFUpload = (fileId, name, type, size) => {
    this.setState({
      tsPDFFileId: fileId, tsPDFName: name, tsPDFType: type, tsPDFSize: size,
      tsPDFUploadSubmitted: true, tsPDFUploadSuccessMsg: null, tsPDFUploadErrorList: []
    })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet/pdf/validation`,
      this.onTSPDFUploadCallback, {}
    )
  }

  onTSPDFUploadCallback = (response) => {
    this.setState({ tsPDFUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      tsPDFUploadSuccessMsg: response.success,
      tsPDFUploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          tsPDFUploadSuccessMsg: null
        })
      }, 5000)
    }
  }

  onGenLeegTSfromHTML = () => {
    let submitted = this.state.genLeegTSfromHTMLSubmitted
    if (submitted)
      return

    this.setState({
      genLeegTSfromHTMLSuccessMsg: null,
      genLeegTSfromHTMLErrorList: [],
      genLeegTSfromHTMLSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet/esign`,
      this.onGenLeegTSfromHTMLCallback, {}
    )
  }

  onGenLeegTSfromHTMLCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      genLeegTSfromHTMLSuccessMsg: response.success,
      genLeegTSfromHTMLErrorList: errorList,
      genLeegTSfromHTMLSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          genLeegTSfromHTMLSuccessMsg: null
        })
        this.props.onRefreshClick('noBusy')
      }, 5000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ genLeegTSfromHTMLErrorList: errorList })
      }, 5000)
    }
  }

  getDocuments = () => {
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/generated`,
      this.getDocumentsCallback, null, null
    )
  }

  getDocumentsCallback = (response) => {
    let documentList = response.documentList
    this.setState({
      documentList: documentList
    })
  }

  onDownloadDocClick = (event) => {
    let documentId = event.currentTarget.getAttribute('data-type')
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/${documentId}/fileDownloadSignedUrl`,
      this.onDownloadDocClickCallback, null, null
    )
  }

  onDownloadDocClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default TermSheetSignSF
